export default "__VITE_ASSET__NW2UmLaQ__"